<!-- This condition of product-page class should be removed after activation new PDP in the complex template type. -->
<div id="product-page" [class.product-page]="!productPageFacade.isProductPageRevampEnabled || applyProductWrapping">
    @if(!productPageFacade.isProductPageRevampEnabled || applyProductWrapping) {
    <div class="header-wrapper">
        <!-- back button -->
        <h-back-button-deprecated
            class="back-button"
            [class.back-button-hidden]="!displayBackButton"
            (goBack)="handleGoBack()"
            [displaySmallMobileBackButton]="true">
            <span class="mobile-only" i18n="@@node--hermes-product-display-default.back" hSrOnlyNoSnippet> Back </span>
            <span class="desktop-only back-text" i18n="@@node--hermes-product-display-default.back"> Back </span>
            <span hSrOnlyNoSnippet>
                {{ "&nbsp;" }}
                <ng-container i18n="@@hermes.accessibility.catalog.link.to-product-grid">
                    to the product grid
                </ng-container>
            </span>
        </h-back-button-deprecated>
    </div>
    }
    <router-outlet></router-outlet>
</div>
@if (breadcrumbSections.length > 0) {
<div class="breadcrumb-container">
    <h-breadcrumb
        [attr.data-testid]="'breadcrumb-product-page'"
        class="product-breadcrumb"
        [breadcrumbSections]="breadcrumbSections"
        (clickEvent)="redirect($event)"
        [breadcrumbTitle]="breadcrumbTitle"></h-breadcrumb
></div>
} @if (zoomActive && zoomAssets.length > 0) { @if(productPageFacade.isProductPageRevampEnabled) {
<h-product-image-zoom
    [assets]="zoomAssets"
    [product]="product"
    [currentAssetUrl]="currentAssetUrl"
    [zoomActive]="zoomActive"
    (zoomActiveChange)="onZoomStatusChange($event)">
</h-product-image-zoom>
} @else {
<h-product-image-zoom-deprecated
    [assets]="zoomAssets"
    [product]="product"
    [currentAssetUrl]="currentAssetUrl"
    [zoomActive]="zoomActive"
    (zoomActiveChange)="onZoomStatusChange($event)">
</h-product-image-zoom-deprecated>
} }

<h-livechat [pageType]="product.templateType"></h-livechat>
